export const Countries = [
  {name : "Afganistan" , code : "AF" , coords:[33.7680065, 66.2385139] }, 
  {name : "Albania" , code : "AL" , coords:[41.000028, 19.9999619] }, 
  {name : "Algieria" , code : "DZ" , coords:[28.0000272, 2.9999825] }, 
  {name : "Andora" , code : "AD" , coords:[42.5407167, 1.5732033] }, 
  {name : "Antigua i Barbuda" , code : "AG" , coords:[17.2234721, -61.9554608] }, 
  {name : "Arabia Saudyjska" , code : "SA" , coords:[25.6242618, 42.3528328] }, 
  {name : "Argentyna" , code : "AR" , coords:[-34.9964963, -64.9672817] }, 
  {name : "Armenia" , code : "AM" , coords:[40.7696272, 44.6736646] }, 
  {name : "Australia" , code : "AU" , coords:[-24.7761086, 134.755] }, 
  {name : "Austria" , code : "AT" , coords:[47.59397, 14.12456] }, 
  {name : "Azerbejdżan" , code : "AZ" , coords:[40.3936294, 47.7872508] }, 
  {name : "Bahamy" , code : "BS" , coords:[24.7736546, -78.0000547] }, 
  {name : "Bahrajn" , code : "BH" , coords:[26.1551249, 50.5344606] }, 
  {name : "Bangladesz" , code : "BD" , coords:[24.4769288, 90.2934413] }, 
  {name : "Barbados" , code : "BB" , coords:[13.1500331, -59.5250305] }, 
  {name : "Belgia" , code : "BE" , coords:[50.6402809, 4.6667145] }, 
  {name : "Belize" , code : "BZ" , coords:[17.1204943, -88.6859028] }, 
  {name : "Benin" , code : "BJ" , coords:[9.5293472, 2.2584408] }, 
  {name : "Bhutan" , code : "BT" , coords:[27.549511, 90.5119273] }, 
  {name : "Białoruś" , code : "BY" , coords:[53.4250605, 27.6971358] }, 
  {name : "Birma" , code : "MM" , coords:[17.1750495, 95.9999652] }, 
  {name : "Boliwia" , code : "BO" , coords:[-17.0568696, -64.9912286] }, 
  {name : "Bośnia i Hercegowina" , code : "BA" , coords:[44.3053476, 17.5961467] }, 
  {name : "Botswana" , code : "BW" , coords:[-23.1681782, 24.5928742] }, 
  {name : "Brazylia" , code : "BR" , coords:[-10.3333333, -53.2] }, 
  {name : "Brunei" , code : "BN" , coords:[4.4137155, 114.5653908] }, 
  {name : "Bułgaria" , code : "BG" , coords:[42.6073975, 25.4856617] }, 
  {name : "Burkina Faso" , code : "BF" , coords:[12.0753083, -1.6880314] }, 
  {name : "Burundi" , code : "BI" , coords:[-3.426449, 29.9324519] }, 
  {name : "Chile" , code : "CL" , coords:[-31.7613365, -71.3187697] }, 
  {name : "Chiny" , code : "CN" , coords:[35.0000663, 104.999955] }, 
  {name : "Chorwacja" , code : "HR" , coords:[45.3658443, 15.6575209] }, 
  {name : "Cypr" , code : "CY" , coords:[34.9823018, 33.1451285] }, 
  {name : "Czad" , code : "TD" , coords:[15.6134137, 19.0156172] }, 
  {name : "Czarnogóra" , code : "ME" , coords:[42.9868853, 19.5180992] }, 
  {name : "Czechy" , code : "CZ" , coords:[49.7439047, 15.3381061] }, 
  {name : "Dania" , code : "DK" , coords:[55.670249, 10.3333283] }, 
  {name : "Demokratyczna Republika Konga" , code : "CD" , coords:[-2.9814344, 23.8222636] }, 
  {name : "Dominika" , code : "DM" , coords:[15.4113138, -61.3653618] }, 
  {name : "Dominikana" , code : "DO" , coords:[19.0974031, -70.3028026] }, 
  {name : "Dżibuti" , code : "DJ" , coords:[11.8145966, 42.8453061] }, 
  {name : "Egipt" , code : "EG" , coords:[26.2540493, 29.2675469] }, 
  {name : "Ekwador" , code : "EC" , coords:[-1.3397668, -79.3666965] }, 
  {name : "Erytrea" , code : "ER" , coords:[15.9500319, 37.9999668] }, 
  {name : "Estonia" , code : "EE" , coords:[58.7523778, 25.3319078] }, 
  {name : "Etiopia" , code : "ET" , coords:[10.2116702, 38.6521203] }, 
  {name : "Fidżi" , code : "FJ" , coords:[-18.1239696, 179.0122737] }, 
  {name : "Filipiny" , code : "PH" , coords:[12.7503486, 122.7312101] }, 
  {name : "Finlandia" , code : "FI" , coords:[63.2467777, 25.9209164] }, 
  {name : "Francja" , code : "FR" , coords:[46.603354, 1.8883335] }, 
  {name : "Gabon" , code : "GA" , coords:[-0.8999695, 11.6899699] }, 
  {name : "Gambia" , code : "GM" , coords:[13.470062, -15.4900464] }, 
  {name : "Ghana" , code : "GH" , coords:[8.0300284, -1.0800271] }, 
  {name : "Grecja" , code : "GR" , coords:[38.9953683, 21.9877132] }, 
  {name : "Grenada" , code : "GD" , coords:[12.1360374, -61.6904045] }, 
  {name : "Gruzja" , code : "GE" , coords:[41.6808672, 44.0287806] }, 
  {name : "Gujana" , code : "GY" , coords:[4.8417097, -58.6416891] }, 
  {name : "Gwatemala" , code : "GT" , coords:[15.5855545, -90.345759] }, 
  {name : "Gwinea" , code : "GN" , coords:[10.7226226, -10.7083587] }, 
  {name : "Gwinea Bissau" , code : "GW" , coords:[11.815215, -15.2351044] }, 
  {name : "Gwinea Równikowa" , code : "GQ" , coords:[1.613172, 10.5170357] }, 
  {name : "Haiti" , code : "HT" , coords:[19.1399952, -72.3570972] }, 
  {name : "Hiszpania" , code : "ES" , coords:[39.3260685, -4.8379791] }, 
  {name : "Holandia" , code : "NL" , coords:[52.24764975, 5.541246849406163] }, 
  {name : "Niderlandy" , code : "NL" , coords:[52.24764975, 5.541246849406163] }, 
  {name : "Honduras" , code : "HN" , coords:[15.2572432, -86.0755145] }, 
  {name : "Indie" , code : "IN" , coords:[22.3511148, 78.6677428] }, 
  {name : "Indonezja" , code : "ID" , coords:[-2.4833826, 117.8902853] }, 
  {name : "Irak" , code : "IQ" , coords:[33.0955793, 44.1749775] }, 
  {name : "Iran" , code : "IR" , coords:[32.6475314, 54.5643516] }, 
  {name : "Irlandia" , code : "IE" , coords:[52.865196, -7.9794599] }, 
  {name : "Islandia" , code : "IS" , coords:[64.9841821, -18.1059013] }, 
  {name : "Izrael" , code : "IL" , coords:[30.8124247, 34.8594762] }, 
  {name : "Jamajka" , code : "JM" , coords:[18.1850507, -77.3947693] }, 
  {name : "Japonia" , code : "JP" , coords:[36.5748441, 139.2394179] }, 
  {name : "Jemen" , code : "YE" , coords:[16.3471243, 47.8915271] }, 
  {name : "Jordania" , code : "JO" , coords:[31.1667049, 36.941628] }, 
  {name : "Kambodża" , code : "KH" , coords:[12.5433216, 104.8144914] }, 
  {name : "Kamerun" , code : "CM" , coords:[4.6125522, 13.1535811] }, 
  {name : "Kanada" , code : "CA" , coords:[61.0666922, -107.991707] }, 
  {name : "Katar" , code : "QA" , coords:[25.3336984, 51.2295295] }, 
  {name : "Kazachstan" , code : "KZ" , coords:[48.1012954, 66.7780818] }, 
  {name : "Kenia" , code : "KE" , coords:[1.4419683, 38.4313975] }, 
  {name : "Kirgistan" , code : "KG" , coords:[41.5089324, 74.724091] }, 
  {name : "Kiribati" , code : "KI" , coords:[0.3448612, 173.6641773] }, 
  {name : "Kolumbia" , code : "CO" , coords:[4.099917, -72.9088133] }, 
  {name : "Komory" , code : "KM" , coords:[-12.2045176, 44.2832964] }, 
  {name : "Kongo" , code : "CD" , coords:[-2.9814344, 23.8222636] }, 
  {name : "Korea Południowa" , code : "KR" , coords:[36.638392, 127.6961188] }, 
  {name : "Korea Północna" , code : "KP" , coords:[40.3736611, 127.0870417] }, 
  {name : "Kosowo" , code : "XK" , coords:[42.5869578, 20.9021231] }, 
  {name : "Kostaryka" , code : "CR" , coords:[10.2735633, -84.0739102] }, 
  {name : "Kuba" , code : "CU" , coords:[23.0131338, -80.8328748] }, 
  {name : "Kuwejt" , code : "KW" , coords:[29.2733964, 47.4979476] }, 
  {name : "Laos" , code : "LA" , coords:[20.0171109, 103.378253] }, 
  {name : "Lesotho" , code : "LS" , coords:[-29.6039267, 28.3350193] }, 
  {name : "Liban" , code : "LB" , coords:[33.8750629, 35.843409] }, 
  {name : "Liberia" , code : "LR" , coords:[5.7499721, -9.3658524] }, 
  {name : "Libia" , code : "LY" , coords:[26.8234472, 18.1236723] }, 
  {name : "Liechtenstein" , code : "LI" , coords:[47.1416307, 9.5531527] }, 
  {name : "Litwa" , code : "LT" , coords:[55.3500003, 23.7499997] }, 
  {name : "Luksemburg" , code : "LU" , coords:[49.8158683, 6.1296751] }, 
  {name : "Łotwa" , code : "LV" , coords:[56.8406494, 24.7537645] }, 
  {name : "Macedonia" , code : "MK" , coords:[41.6171214, 21.7168387] }, 
  {name : "Madagaskar" , code : "MG" , coords:[-18.9249604, 46.4416422] }, 
  {name : "Malawi" , code : "MW" , coords:[-13.2687204, 33.9301963] }, 
  {name : "Malediwy" , code : "MV" , coords:[3.7203503, 73.2244152] }, 
  {name : "Malezja" , code : "MY" , coords:[4.5693754, 102.2656823] }, 
  {name : "Mali" , code : "ML" , coords:[16.3700359, -2.2900239] }, 
  {name : "Malta" , code : "MT" , coords:[35.8885993, 14.4476911] }, 
  {name : "Maroko" , code : "MA" , coords:[31.1728205, -7.3362482] }, 
  {name : "Mauretania" , code : "MR" , coords:[20.2540382, -9.2399263] }, 
  {name : "Mauritius" , code : "MU" , coords:[-20.2759451, 57.5703566] }, 
  {name : "Meksyk" , code : "MX" , coords:[23.6585116, -102.0077097] }, 
  {name : "Mikronezja" , code : "FM" , coords:[8.6062347, 151.832744331612] }, 
  {name : "Mołdawia" , code : "MD" , coords:[47.2879608, 28.5670941] }, 
  {name : "Monako" , code : "MC" , coords:[43.7323492, 7.4276832] }, 
  {name : "Mongolia" , code : "MN" , coords:[46.8250388, 103.8499736] }, 
  {name : "Mozambik" , code : "MZ" , coords:[-19.302233, 34.9144977] }, 
  {name : "Namibia" , code : "NA" , coords:[-23.2335499, 17.3231107] }, 
  {name : "Nauru" , code : "NR" , coords:[-0.5252306, 166.9324426] }, 
  {name : "Nepal" , code : "NP" , coords:[28.3780464, 83.9999901] }, 
  {name : "Niemcy" , code : "DE" , coords:[51.1638175, 10.4478313] }, 
  {name : "Niger" , code : "NE" , coords:[17.7356214, 9.3238432] }, 
  {name : "Nigeria" , code : "NG" , coords:[9.6000359, 7.9999721] }, 
  {name : "Nikaragua" , code : "NI" , coords:[12.6090157, -85.2936911] }, 
  {name : "Norwegia" , code : "NO" , coords:[61.1529386, 8.7876653] }, 
  {name : "Nowa Zelandia" , code : "NZ" , coords:[-41.5000831, 172.8344077] }, 
  {name : "Oman" , code : "OM" , coords:[21.0000287, 57.0036901] }, 
  {name : "Pakistan" , code : "PK" , coords:[30.3308401, 71.247499] }, 
  {name : "Palau" , code : "PW" , coords:[5.3783537, 132.9102573] }, 
  {name : "Panama" , code : "PA" , coords:[8.559559, -81.1308434] }, 
  {name : "Papua-Nowa Gwinea" , code : "PG" , coords:[-5.6816069, 144.2489081] }, 
  {name : "Paragwaj" , code : "PY" , coords:[-23.3165935, -58.1693445] }, 
  {name : "Peru" , code : "PE" , coords:[-6.8699697, -75.0458515] }, 
  {name : "Polska" , code : "PL" , coords:[52.215933, 19.134422] }, 
  {name : "Portugalia" , code : "PT" , coords:[39.6621648, -8.1353519] }, 
  {name : "Republika Południowej Afryki" , code : "ZA" , coords:[-28.8166236, 24.991639] }, 
  {name : "Republika Środkowoafrykańska" , code : "CF" , coords:[7.0323598, 19.9981227] }, 
  {name : "Republika Zielonego Przylądka" , code : "CV" , coords:[16.0000552, -24.0083947] }, 
  {name : "Rosja" , code : "RU" , coords:[64.6863136, 97.7453061] }, 
  {name : "Rumunia" , code : "RO" , coords:[45.9852129, 24.6859225] }, 
  {name : "Rwanda" , code : "RW" , coords:[-1.9646631, 30.0644358] }, 
  {name : "Saint Kitts i Nevis" , code : "KN" , coords:[17.250512, -62.6725973] }, 
  {name : "Saint Lucia" , code : "LC" , coords:[13.8250489, -60.975036] }, 
  {name : "Saint Vincent i Grenadyny" , code : "VC" , coords:[12.90447, -61.2765569] }, 
  {name : "Salwador" , code : "SV" , coords:[13.8000382, -88.9140683] }, 
  {name : "Samoa" , code : "WS" , coords:[-13.7693895, -172.12005] }, 
  {name : "San Marino" , code : "SM" , coords:[43.9458623, 12.458306] }, 
  {name : "Senegal" , code : "SN" , coords:[14.4750607, -14.4529612] }, 
  {name : "Serbia" , code : "RS" , coords:[44.1534121, 20.55144] }, 
  {name : "Seszele" , code : "SC" , coords:[-4.6574977, 55.4540146] }, 
  {name : "Sierra Leone" , code : "SL" , coords:[8.6400349, -11.8400269] }, 
  {name : "Singapur" , code : "SG" , coords:[1.357107, 103.8194992] }, 
  {name : "Słowacja" , code : "SK" , coords:[48.7411522, 19.4528646] }, 
  {name : "Słowenia" , code : "SI" , coords:[46.1199444, 14.8153333] }, 
  {name : "Somalia" , code : "SO" , coords:[8.3676771, 49.083416] }, 
  {name : "Sri Lanka" , code : "LK" , coords:[7.5554942, 80.7137847] }, 
  {name : "Stany Zjednoczone" , code : "US" , coords:[39.7837304, -100.445882] }, 
  {name : "Suazi" , code : "SZ" , coords:[-26.5624806, 31.3991317] }, 
  {name : "Sudan" , code : "SD" , coords:[14.5844444, 29.4917691] }, 
  {name : "Sudan Południowy" , code : "SS" , coords:[7.8699431, 29.6667897] }, 
  {name : "Surinam" , code : "SR" , coords:[4.1413025, -56.0771187] }, 
  {name : "Syria" , code : "SY" , coords:[34.6401861, 39.0494106] }, 
  {name : "Szwajcaria" , code : "CH" , coords:[46.7985624, 8.2319736] }, 
  {name : "Szwecja" , code : "SE" , coords:[59.6749712, 14.5208584] }, 
  {name : "Tadżykistan" , code : "TJ" , coords:[38.6281733, 70.8156541] }, 
  {name : "Tajlandia" , code : "TH" , coords:[14.8971921, 100.83273] }, 
  {name : "Tanzania" , code : "TZ" , coords:[-6.5247123, 35.7878438] }, 
  {name : "Timor Wschodni" , code : "TL" , coords:[-8.7443169, 126.063482] }, 
  {name : "Togo" , code : "TG" , coords:[8.7800265, 1.0199765] }, 
  {name : "Tonga" , code : "TO" , coords:[-19.9160819, -175.202642] }, 
  {name : "Trynidad i Tobago" , code : "TT" , coords:[10.7466905, -61.0840075] }, 
  {name : "Tunezja" , code : "TN" , coords:[33.8439408, 9.400138] }, 
  {name : "Turcja" , code : "TR" , coords:[38.9597594, 34.9249653] }, 
  {name : "Turkmenistan" , code : "TM" , coords:[39.3763807, 59.3924609] }, 
  {name : "Tuvalu" , code : "TV" , coords:[-8.6405212, 179.1582918181797] }, 
  {name : "Uganda" , code : "UG" , coords:[1.5333554, 32.2166578] }, 
  {name : "Ukraina" , code : "UA" , coords:[49.4871968, 31.2718321] }, 
  {name : "Urugwaj" , code : "UY" , coords:[-32.8755548, -56.0201525] }, 
  {name : "Uzbekistan" , code : "UZ" , coords:[41.32373, 63.9528098] }, 
  {name : "Vanuatu" , code : "VU" , coords:[-16.5255069, 168.1069154] }, 
  {name : "Watykan" , code : "VA" , coords:[41.903411, 12.4528527] }, 
  {name : "Wenezuela" , code : "VE" , coords:[8.0018709, -66.1109318] }, 
  {name : "Węgry" , code : "HU" , coords:[47.1817585, 19.5060937] }, 
  {name : "Wielka Brytania" , code : "GB" , coords:[54.7023545, -3.2765753] }, 
  {name : "Wietnam" , code : "VN" , coords:[15.9266657, 107.9650855] }, 
  {name : "Włochy" , code : "IT" , coords:[42.6384261, 12.674297] }, 
  {name : "Wybrzeże Kości Słoniowej" , code : "CI" , coords:[7.9897371, -5.5679458] }, 
  {name : "Wyspy Marshalla" , code : "MH" , coords:[8.230816999999998, 167.7953223704529] }, 
  {name : "Wyspy Salomona" , code : "SB" , coords:[-8.7053941, 159.1070693851845] }, 
  {name : "Wyspy Świętego Tomasza i Książęca" , code : "ST" , coords:[0.9713095, 7.02255] }, 
  {name : "Zambia" , code : "ZM" , coords:[-14.5189121, 27.5589884] }, 
  {name : "Zimbabwe" , code : "ZW" , coords:[-18.4554963, 29.7468414] }, 
  {name : "Zjednoczone Emiraty Arabskie" , code : "AE" , coords:[24.0002488, 53.9994829] },
  ];